"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "APPLICATION_LOG_FORMAT_V2", {
  enumerable: true,
  get: function get() {
    return _NuiLogValidator.APPLICATION_LOG_FORMAT_V2;
  }
});
Object.defineProperty(exports, "CategorizedError", {
  enumerable: true,
  get: function get() {
    return _CategorizedError.default;
  }
});
Object.defineProperty(exports, "NuiAppSecLogCategory", {
  enumerable: true,
  get: function get() {
    return _AppSecLogger.NuiAppSecLogCategory;
  }
});
Object.defineProperty(exports, "NuiLogLevel", {
  enumerable: true,
  get: function get() {
    return _NuiLogger.NuiLogLevel;
  }
});
Object.defineProperty(exports, "NuiLogValidator", {
  enumerable: true,
  get: function get() {
    return _NuiLogValidator.NuiLogValidator;
  }
});
Object.defineProperty(exports, "NuiLogger", {
  enumerable: true,
  get: function get() {
    return _NuiLogger.NuiLogger;
  }
});
Object.defineProperty(exports, "appSecLogger", {
  enumerable: true,
  get: function get() {
    return _AppSecLogger.default;
  }
});
exports.default = void 0;
var _NuiLogger = _interopRequireWildcard(require("./logger/NuiLogger"));
var _AppSecLogger = _interopRequireWildcard(require("./appSecLogger/AppSecLogger"));
var _CategorizedError = _interopRequireDefault(require("./CategorizedError"));
var _NuiLogValidator = require("./NuiLogValidator");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _default = exports.default = _NuiLogger.default;